export function setupMockDate() {
  if (process.env.APP_ENV === 'test') {
    const mockDate = '2024-01-07T00:00:00.000Z'
    class CustomDate extends Date {
      constructor(...args: ConstructorParameters<typeof Date>) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if ((args as any).length === 0) {
          super(mockDate)
        } else {
          super(...args)
        }
      }
      static now(): number {
        return new Date(mockDate).getTime()
      }
    }

    // Prepare a global reference
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const globalAny: any = typeof global !== 'undefined' ? global : window

    // Assign CustomDate to global Date
    if (typeof window === 'undefined') {
      globalAny.Date = CustomDate as unknown as DateConstructor
    } else {
      globalAny.Date = CustomDate as unknown as DateConstructor
    }
  }
}
